import { cx } from '@hrworks/design-system/functions';

import { S } from './ModalFooter.styles';
import type { ModalFooterProps } from './ModalFooter.types';

export const ModalFooter = ({ className, ...props }: ModalFooterProps) => (
  <S.Footer className={cx(S.cls.Footer, className)} {...props} />
);
